const isNodeLike = () => typeof process !== 'undefined' && !!process.versions?.node;

const getNativeStorage = () => {
  if (isNodeLike() || typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

const hasBrowserStorage = () => Boolean(getNativeStorage());

const safeExecute = (operation, fallback) => {
  const storage = getNativeStorage();
  if (!storage) return fallback;
  try {
    return operation(storage);
  } catch (error) {
    console.error('[safeStorage] Storage operation failed:', error);
    return fallback;
  }
};

export const safeStorage = {
  isAvailable: hasBrowserStorage,
  getItem(key, fallback = null) {
    const value = safeExecute((storage) => storage.getItem(key), fallback);
    return typeof value === 'string' ? value : fallback;
  },
  setItem(key, value) {
    if (value === undefined) {
      this.removeItem(key);
      return;
    }
    safeExecute((storage) => storage.setItem(key, value));
  },
  removeItem(key) {
    safeExecute((storage) => storage.removeItem(key));
  },
  clear() {
    safeExecute((storage) => storage.clear());
  },
  getJSON(key, fallback = null) {
    const raw = this.getItem(key);
    if (raw === null || raw === undefined) return fallback;
    try {
      return JSON.parse(raw);
    } catch (error) {
      console.error(`[safeStorage] Failed to parse JSON for key "${key}":`, error);
      return fallback;
    }
  },
  setJSON(key, value) {
    if (value === undefined) {
      this.removeItem(key);
      return;
    }
    this.setItem(key, JSON.stringify(value));
  }
};

export default safeStorage;

